module.exports = __webpack_public_path__ + "img/checkBoxVip_bgb.588f8bc9.png";